export default {
  computed: {
    signInFullPath() {
      return this.$route.path === '/' || this.$route.path === '/sign_in'
        ? '/sign_in'
        : `/sign_in?return_to=${encodeURIComponent(this.$route.fullPath)}`
    }
  }
}
